import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonDeleteButton, CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol } from '../../../Utility/Constants'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PrintIcon from '@mui/icons-material/Print';

const active_status = [{ label: "All", value: "" }, { label: "Active", value: "true" }, { label: "In Active", value: "false" }]

export default function StoreSubCategory() {
    const history = useHistory();
    const location = useLocation();
    const [vendorList, setvendorList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [subCategoryName, setSubCategoryName] = useState('');
    const [subCategoryCode, setSubCategoryCode] = useState('');
    const [CategoryName, setCategoryName] = useState(null);
    const [filterActiveStatus, setFilterActiveStatus] = useState({ label: "All", value: "" });
    const [filterCatogory, setFilterCatogory] = useState(null);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [EditListID, setEditListID] = useState(null);
    const [DeleteIds, setDeleteIds] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [categoryList, setCatogoryList] = useState([]);


    useEffect(() => {
        getSubCategoryList()
        getCategoryList()
    }, [])


    const getCategoryList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setCatogoryList(response.data.data?.filter((item) => item?.is_active) || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getSubCategoryList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(`${Serviceurls.STORE_SUB_CATEGORY}?category_id=${filterCatogory ? filterCatogory?.id : ""}&status=${filterActiveStatus?.value}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const filData = response.data.data
                        setvendorList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'CategoryName':
                setCategoryName(val);
                break

        }
    }

    const onChangeHandler = (e, name) => {
        let value = e.target.value
        switch (name) {
            case 'subCategoryName':
                if (value === "" || value.length <= 50) {
                    setSubCategoryName(value)
                }
                break
        }
    }

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    value={val ? val : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width) => {
        return (
            <Box>
                <Autocomplete
                    size={'small'}
                    options={list}
                    name={name}
                    getOptionLabel={(option) => name === 'CategoryName' ? `${option.category_name}` : option}
                    value={val}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const TableHeaderBtns = () => {
        return (
            <Box>
                <Tooltip title="Filter" placement='top' arrow>
                    <IconButton onClick={() => { setFilterOpen(true) }}><FilterAltIcon color='primary' /></IconButton>
                </Tooltip>
            </Box>
        )
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText fromStore={true} isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} renderComponent={TableHeaderBtns} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = vendorList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        vendorList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'sub_category_code', headerName: 'Sub Category Code', flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.sub_category_code ? params?.row?.sub_category_code : '-'}</Box>)

            },
            {
                field: 'sub_category_name', headerName: 'Sub Category Name', flex: 0.3,
                renderCell: (params) => (params.row.sub_category_name ? params.row.sub_category_name?.length > 40 ?
                    <Tooltip placement="top" title={params.row.sub_category_name}><Typography fontSize={'0.9vw'}>{params.row.sub_category_name?.slice(0, 40) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.sub_category_name}</Typography> : '-')

            },
            {
                field: 'category_name', headerName: 'Category Name', flex: 0.3,
                renderCell: (params) => (params.row.category_name ? params.row.category_name?.length > 40 ?
                    <Tooltip placement="top" title={params.row.category_name}><Typography fontSize={'0.9vw'}>{params.row.category_name?.slice(0, 40) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.category_name}</Typography> : '-')

            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.1,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.is_active ? "Active" : 'InActive'}</Box>)
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={delIDs?.length > 0}
                                onClick={() => {
                                    setSubCategoryCode(params.row.sub_category_code ? params.row.sub_category_code : "");
                                    setSubCategoryName(params.row.sub_category_name ? params.row.sub_category_name : "");
                                    setCategoryName(categoryList?.find((list) => (list?.id === params.row.category_id)))
                                    setIsActive(params.row.is_active)
                                    setEditID(params.row.id)
                                }} />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '61vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={vendorList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    // page={page}
                    // pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    // onPageChange={(newPage) => { setpage(newPage) }}
                    // onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    // rowsPerPageOptions={[10, 20, 30]}
                    // pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setSubCategoryCode('');
        setSubCategoryName('');
        setCategoryName(null)
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
        setIsActive(true)
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
        setEditID(null)
    }

    const addCategoryendorDetails = () => {
        try {
            if (!subCategoryName) {
                errorMessage('Please Enter Sub Category Name')
            } else if (!CategoryName?.id) {
                errorMessage('Please Select Category')
            } else {
                let data = {
                    'category_id': CategoryName?.id,
                    "sub_category_name": subCategoryName,
                    'is_active': isActive
                }
                if (EditID) {
                    data["id"] = EditID
                    RestAPIService.updateWithOutId(data, Serviceurls.STORE_SUB_CATEGORY)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getSubCategoryList()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                } else {
                    RestAPIService.create(data, Serviceurls.STORE_SUB_CATEGORY)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getSubCategoryList()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                }
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteVendor = () => {
        try {
            RestAPIService.delete(`${Serviceurls.STORE_SUB_CATEGORY}?ids=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getSubCategoryList()
                        closeFilter();
                        clearFunction()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={active_status}
                            getOptionLabel={(option) => option?.label}
                            value={filterActiveStatus}
                            onChange={(event, newValue) => {
                                setFilterActiveStatus(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Active Status'}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={categoryList}
                            getOptionLabel={(option) => option?.category_name}
                            value={filterCatogory}
                            onChange={(event, newValue) => {
                                setFilterCatogory(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Category'}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setFilterCatogory(null)
                            setFilterActiveStatus({ label: "All", value: "" })
                        }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getSubCategoryList();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '15.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {textBox("Sub Category Code", 'subCategoryCode', subCategoryCode, '20vw', true)}
                        {textBox("Sub Category Name *", 'subCategoryName', subCategoryName, '20vw')}
                        {autoComplete("Category Name *", 'CategoryName', CategoryName, categoryList, '15vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' disabled={!EditID} />} label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} onClick={() => { addCategoryendorDetails() }}>{EditID ? "Update" : "Add"}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '61vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this sub category ?`}
                    AlertNote={"If you remove this sub category, the associated products and vendor mapping will also be deleted."}
                    deleteAlertPopupClose={closeFilter.bind(this)}
                    removeData={deleteVendor.bind(this)}
                />
                : null}
        </Box>
    )
}
